import React from 'react';
import { 
  Compass, Eye, Heart, Brain, Shield, Link2,
  FileInput, Calculator, MessageSquare, Zap, CheckCircle,
  Ghost, Lock, Database, Pen, Activity, Headphones,
  BookOpen, Building
} from 'lucide-react';

const iconMap = {
  compass: Compass,
  eye: Eye,
  heart: Heart,
  brain: Brain,
  shield: Shield,
  link: Link2,
  input: FileInput,
  calculate: Calculator,
  explain: MessageSquare,
  optimize: Zap,
  verify: CheckCircle,
  ghost: Ghost,
  lock: Lock,
  database: Database,
  pen: Pen,
  activity: Activity,
  headphones: Headphones,
  book: BookOpen,
  building: Building
};

export function DynamicIcon({ name, className = "w-5 h-5", ...props }) {
  const IconComponent = iconMap[name] || Activity;
  return <IconComponent className={className} {...props} />;
}

export default DynamicIcon;
